import { IOfficeRegistrationRow } from "../../../interfaces/models/IDashboardData";

interface IRegionCardProps {
  region: string;
  offices: Pick<IOfficeRegistrationRow, "name" | "attendee">[];
  onClick: (region: string) => void;
}

export const RegionCard = ({ region, offices, onClick }: IRegionCardProps) => {
  const attendingOffices = offices?.filter((office) => office.attendee).length;
  const totalOffices = offices?.length;

  const renderRegionPieChart = (value: number, total: number, size: number = 60) => {
    const percentage = total > 0 ? (value / total) * 100 : 0;
    const circumference = 2 * Math.PI * (size / 2 - 5);
    const offset = circumference - (percentage / 100) * circumference;

    return (
      <div className="relative" style={{ width: size, height: size }}>
        <svg className="transform -rotate-90" width={size} height={size}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={size / 2 - 5}
            fill="none"
            className="stroke-gray-200"
            strokeWidth="8"
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={size / 2 - 5}
            fill="none"
            className="stroke-blue-600"
            strokeWidth="8"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-xs font-semibold text-gray-700">{Math.round(percentage)}%</span>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col w-full min-w-0 p-4 rounded-lg border border-gray-300 bg-white gap-2">
      <div className="font-semibold">{region}</div>
      <div className="flex items-center gap-4">
        {renderRegionPieChart(attendingOffices, totalOffices, 60)}
        <div>
          <div className="text-lg font-bold text-gray-900">{attendingOffices} firms</div>
          <div className="text-xs text-gray-600">
            {attendingOffices} of {totalOffices}
          </div>
        </div>
      </div>
      <div
        className="text-xs text-blue-600 font-medium cursor-pointer hover:underline"
        onClick={() => onClick(region)}
      >
        Member Firm Status &gt;
      </div>
    </div>
  );
};
